import { createApp } from 'vue';
import SlidecountOptions from './slidecount-options.vue';
import PaginationIndicator from './pagination-indicator.vue';

export function pagination(el) {
    createApp({
        components : { PaginationIndicator, SlidecountOptions }
    }).mount(el);
}